import { createSlice } from '@reduxjs/toolkit';

const scaleInfoSlice = createSlice({
  name: 'scaleInfo',
  initialState: {
    operator: {
      id: '',
      name: '',
    },
    packagedGoodsControl: {
      id: '',
      customerId: '',
      name: '',
      t1ErrorCount: null,
      t2ErrorCount: null,
      avgValue: null,
      minAcceptableAvgValue: null,
      measurements: [],
      controlPhase1Quantity: null,
      controlTotalQuantity: null,
      measurementsCount: null,
    },
    scaleSettings: { communicationMode: null, stableMeasurementEnabled: false },
    currentScaleId: '',
    unit: null,
  },
  reducers: {
    setScaleInfo(state, value) {
      const scaleInfo = value.payload;
      state.operator = scaleInfo.operator;
      state.packagedGoodsControl = scaleInfo.packagedGoodsControl;
      state.scaleSettings = scaleInfo.scaleSettings;
      state.currentScaleId = scaleInfo.id;
      state.unit = scaleInfo.unit;
    },

    setOperatorInfo(state, value) {
      if (state.currentScaleId !== value.payload.scaleId) {
        return;
      }

      state.operator = value.payload.operator;
    },
    setPackagedGoodsControlInfo(state, value) {
      if (state.packagedGoodsControl?.id !== value.payload.id) {
        state.packagedGoodsControl = value.payload;
        return;
      }
      const existingMeasurements = state.packagedGoodsControl.measurements || [];
      const newMeasurements = value.payload.measurements || [];

      // Merge measurements, avoiding duplicates
      const mergedMeasurements = [
        ...newMeasurements.filter((newMeas) => !existingMeasurements.some((existMeas) => existMeas.id === newMeas.id)),
        ...existingMeasurements,
      ];
      state.packagedGoodsControl = {
        ...value.payload,
        measurements: mergedMeasurements,
      };
    },
    setScaleSettingsInfo(state, value) {
      if (state.currentScaleId !== value.payload.scaleId) {
        return;
      }

      state.scaleSettings = value.payload.scaleSettings;
    },
    clearPackagedGoodsControlInfo(state, value) {
      if (state.packagedGoodsControl?.id !== value.payload) {
        return;
      }
      state.packagedGoodsControl = {
        id: '',
        customerId: '',
        name: '',
        t1ErrorCount: null,
        t2ErrorCount: null,
        avgValue: null,
        minAcceptableAvgValue: null,
        measurements: [],
        controlPhase1Quantity: null,
        controlTotalQuantity: null,
        measurementsCount: null,
      };
    },
  },
});

export const scaleInfoActions = scaleInfoSlice.actions;
export default scaleInfoSlice;
